<template>
  <block-item-card
    :min-height="300"
    :title="$t('RiskLiquidity.Section.KeyLiquidityRatios.Title')"
    :tooltip="$t('RiskLiquidity.Section.KeyLiquidityRatios.Tooltip')"
  >
    <v-row class="block-container">
      <v-col
        v-for="(chartConfig, index) in transformedChartConfigs"
        :key="index"
        :cols="12"
        :md="6"
      >
        <key-liquidity-ratio-block
          :chart-data="chartConfig.data"
          :title="chartConfig.title"
          :subtitle="chartConfig.subtitle"
          :tooltip="chartConfig.tooltip"
          :chart-height="chartConfig.chartHeight"
          :line-color="chartConfig.lineColor"
          :area-opacity="chartConfig.areaOpacity"
          :area-opacity-end="chartConfig.areaOpacityEnd"
          :show-area="chartConfig.showArea"
          :smooth-line="chartConfig.smoothLine"
          :line-width="chartConfig.lineWidth"
          :symbol-size="chartConfig.symbolSize"
          :format="chartConfig.format"
          :base-currency="chartConfig.baseCurrency"
        />
      </v-col>
    </v-row>
  </block-item-card>
</template>

<script>
import KeyLiquidityRatioBlock from './KeyLiquidityRatioBlock.vue'
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'

export default {
  name      : 'KeyLiquidityRatios',
  components: {
    KeyLiquidityRatioBlock,
    BlockItemCard
  },
  dataStore: {
    monitoringLiquidity: 'RiskLiquidity.MonitoringLiquidity.Data'
  },
  data () {
    return {
      chartConfigs: []
    }
  },
  computed: {
    transformedChartConfigs () {
      if (!this.monitoringLiquidity?.liquidityKeyRatios) return []

      const colorPalette = [
        'synthesis-ui-orange-01',
        'synthesis-ui-green-02',
        'synthesis-ui-blue-04',
        'synthesis-ui-yellow-01',
        'synthesis-ui-purple-02',
        'synthesis-brand-light-blue',
        'synthesis-ui-red-03'
      ]

      return this.monitoringLiquidity.liquidityKeyRatios.map((ratio, index) => {
        const historicalData = ratio.historicalItems || []
        const currentRatio = ratio.currentItem
        const format = ratio.format

        return {
          title         : ratio.title,
          subtitle      : this.$t('RiskLiquidity.Section.KeyLiquidityRatios.Description'),
          tooltip       : this.$t('RiskLiquidity.Section.KeyLiquidityRatios.Tooltip'),
          chartHeight   : 250,
          lineColor     : colorPalette[index % colorPalette.length],
          areaOpacity   : 0.3,
          areaOpacityEnd: 0.05,
          showArea      : true,
          smoothLine    : true,
          lineWidth     : 3,
          symbolSize    : 10,
          format        : format,
          baseCurrency  : this.monitoringLiquidity.baseCurrency,
          data          : {
            dates : historicalData.map(item => item.date),
            values: historicalData.map(item => item.value),
            change: Math.floor(currentRatio.value)
          }
        }
      })
    }
  },
  methods: {}
}
</script>

<style scoped>
 .block-container {
  padding: 0px 16px 16px;
 }
</style>
